import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './services/auth';
import StaffShell from './components/StaffShell';
import Login from './pages/Login';
import Hostess from './pages/Hostess';
import Dashboard from './pages/admin/Dashboard';
import Stocks from './pages/admin/Stocks';
import DailyQuotas from './pages/admin/DailyQuotas';
import Participants from './pages/admin/Participants';
import Play from './game/Play';

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/hotesse" replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={['admin', 'super_admin'].includes(user.role) ? '/admin' : '/hotesse'} replace />;
}

const ADMIN = ['admin', 'super_admin'];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/jeu/:token" element={<Play />} />
          <Route element={<StaffShell />}>
            <Route path="/login" element={<Login />} />
            <Route path="/hotesse" element={<Guard><Hostess /></Guard>} />
            <Route path="/hostess" element={<Navigate to="/hotesse" replace />} />
            <Route path="/admin" element={<Guard roles={ADMIN}><Dashboard /></Guard>} />
            <Route path="/admin/stocks" element={<Guard roles={ADMIN}><Stocks /></Guard>} />
            <Route path="/admin/quotas" element={<Guard roles={ADMIN}><DailyQuotas /></Guard>} />
            <Route path="/admin/participants" element={<Guard roles={ADMIN}><Participants /></Guard>} />
            <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
            <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
